import { render } from "./manage-content.vue?vue&type=template&id=53306ca2"
import script from "./manage-content.vue?vue&type=script&lang=js"
export * from "./manage-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__